<template>
  <div class="notification">
        <div class="title">通知</div>
        <div class="notification-list" v-for="(item,i) in notificationList" :key="i" @click="readNotification(item)" :class="{'unread':item.status === 'unread'}">
            <div class="img-container">
            </div>
            <div class="info-container">
                <div class="info-title">{{item.title}}</div>
                <div class="info-content">
                    {{item.content}}
                </div>
                <div class="info-tag">
                    <div class="tag">{{item.type}}</div>
                    <div class="date">{{item.create_time}}</div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getNotificationList,readNotification  } from '../../api/notification'; 
export default {
    data(){
        return{
            notificationList:[]
        }
        
    },
    mounted(){
        this.getNotificationList()
    },
    methods:{
        ...mapActions('user', ['getNotificationCount']),
        getNotificationList(){
            getNotificationList({
                userName:this.$store.state.user.userName
            }).then(res => {
                this.notificationList = res.body
            })
        },
        readNotification(item){
            if (item.status == 'read'){
                return 
            }
            readNotification({
                id:item.id
            }).then(res => {
                if (res.status == 'success'){
                    this.getNotificationList()
                    this.getNotificationCount()
                }
            })
        }
    }

}
</script>

<style lang="scss" scoped>
.notification {
    .notification-list{
        background-color:#fff;
        cursor: pointer;
        padding: 10px;
        &.unread {
            background-color: $mainColor;
        }
        .info-content {
            margin: 10px 0;
        }
        .info-tag {
            display: flex;
            font-size: 12px;
            color: $textColor;
            align-items: center;
            .tag {
                border: 1px solid $textColor;
                padding: 3px;
                margin-right: 10px;
            }
        }
    }
}

</style>